import LangEnum from '../../../../lang/LangEnum';
import { BusinessPolicyViolationDTO } from '../../../../services/modules/business-policies/businessPolicyViolation.types';
import {
  ErrorsWithQuantities,
  OrderProductsWithErrors,
} from '../../../../services/modules/order-product/order-product.types';
import { UsedInOfflineMode } from '../../../offline/types/UsedInOfflineMode';
import {
  BusinessPolicyItemViolationView,
  BusinessPolicyViolationSection,
  BusinessPolicyViolationView,
} from '../validate/conditions/businessPolicy/businessPolicyViolation.types';

export enum OrderEditSectionsEnum {
  GENERAL_DATA = 'GENERAL_DATA',
  PRODUCTS = 'PRODUCTS',
  ORDER_CONDITIONS = 'ORDER_CONDITIONS',
}

export type OrderExtraInfo = {
  expected: number;
  quantity?: number;
  type?: string;
};

export interface OrderError {
  message: string;
  messageCode: LangEnum;
  details?: Omit<OrderError, 'details'>[];
  extra?: OrderExtraInfo | BusinessPolicyViolationDTO[];
  section: OrderEditSectionsEnum;
}

export interface OrderSectionErrors {
  errors: OrderError[];
}

export interface ConditionError {
  orderConditionId: string;
  errors: OrderError[];
}

export interface OrderConditionErrors {
  errors: ConditionError[];
}

export interface OrderErrors {
  generalData: OrderError[];
  products: ErrorsWithQuantities;
  conditions: ConditionError[];
}

export type ProductsBusinessPolicyViolationsByItem = Map<string, BusinessPolicyItemViolationView[]>;

export interface OrderEditSectionsContextProps {
  currentSection: OrderEditSectionsEnum;
  handleChangeCurrentSection: (section: OrderEditSectionsEnum) => void;
  isValidatingOrderConditions: boolean;
  hasOrderErrors: boolean;
  hasGeneralDataErrors: boolean;
  hasConditionsErrors: boolean;
  generalDataErrors: string[];
  productsErrors: ErrorsWithQuantities;
  productsBusinessPolicyViolationsByItem: ProductsBusinessPolicyViolationsByItem;
  productsBusinessPolicyViolations: BusinessPolicyViolationView[];
  openPolicyViolationsModal: (violations: BusinessPolicyViolationView[]) => void;
  openPolicyViolationSectionsModal: (sections: BusinessPolicyViolationSection[]) => void;
  conditionsErrors: string[];
  orderProductsWithErrors: OrderProductsWithErrors;
  rawConditionErrors: ConditionError[];
  rawGeneralDataErrors?: OrderError[];
}

export interface OrderEditSectionsContextProviderProps extends UsedInOfflineMode {
  children: React.ReactNode;
}
